import { Component, ReactNode } from 'react'

interface Props {
  children: ReactNode
  /** When nested inside another layout, fill the parent instead of the viewport. */
  compact?: boolean
}
interface State { hasError: boolean; error?: Error }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: { componentStack: string }) {
    console.error('Compass UI crash:', error, info.componentStack)
  }

  render() {
    if (this.state.hasError) {
      const size = this.props.compact ? 'h-full min-h-[200px]' : 'h-screen'
      return (
        <div className={`flex ${size} items-center justify-center bg-background p-8`}>
          <div className="max-w-md space-y-4 text-center">
            <h1 className="font-mono text-2xl text-destructive">Compass UI crashed</h1>
            <p className="text-sm text-muted-foreground">
              {this.state.error?.message ?? 'Unknown error'}
            </p>
            <button
              className="rounded-md bg-primary px-4 py-2 text-sm text-primary-foreground hover:opacity-90"
              onClick={() => window.location.reload()}
            >
              Reload
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
